export default __webpack_public_path__ + "9e1d5b848d16a9b3755dce07c05a6b76.png";